"use client";

import Box from "@mui/material/Box"; // GLOBAL CUSTOM COMPONENTS
import SectionCreator from "./default/section-creator";
import { CAROUSEL_ARROW_STYLE } from "src/lib/components/category-section/bazaar/styles";
import { Carousel } from "../salify-next-layout/default/components/carousel";
import SalifyFallback from "src/lib/components/salify-fallback/default";
import React, { useEffect, useState } from "react";
import { Product } from "src/lib/fetcher/client";
import { useMediaQuery, useTheme } from "@mui/material";
import clsx from "clsx";
import ProductItemHorizontal from "src/lib/components/product-item/horizontal";
import { toAssetImages } from "src/lib/utils";
import LazyImage from "src/lib/components/salify-next-layout/default/components/LazyImage";

// =========================================================

export interface VariantProps {
  featuredOption?: string;
}
const ProductListSection: React.FC<VariantProps> = ({ featuredOption }) => {
  const products = SalifyFallback.useSelect<Product[]>("output:products.data");
  const [isAfterInit, setIsAfterInit] = useState(false);
  const { breakpoints } = useTheme();
  const isMobile = useMediaQuery("(max-width:767px)");
  const responsive = [
    {
      breakpoint: breakpoints.values.md,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: breakpoints.values.sm,
      settings: {
        slidesToShow: 1,
      },
    },
  ];
  const cls = clsx({
    "on-init": !isAfterInit,
  });
  const [slideToShow, setSlideToShow] = useState(1);
  useEffect(() => {
    if (!isMobile) {
      setSlideToShow(4);
    }
  }, [isMobile]);
  return (
    <SectionCreator
      title={
        <LazyImage
          src={toAssetImages("misc/flash-sale-img.png")}
          alt={"flash-sale"}
          width={65}
          height={45}
        />
      }
      seeMoreLink="/collection"
    >
      <div className={cls}>
        <Carousel
          dotColor={undefined}
          slidesToShow={slideToShow}
          initialSlide={0}
          responsive={responsive}
          arrowStyles={CAROUSEL_ARROW_STYLE}
          onInit={() => {
            setIsAfterInit(true);
          }}
        >
          {products.map((item, index) => (
            <Box pb={2} key={index} sx={{ height: "inherit" }}>
              <ProductItemHorizontal {...item} featuredOption={featuredOption} />
            </Box>
          ))}
        </Carousel>
      </div>
    </SectionCreator>
  );
};

export default ProductListSection;
